import { render } from "./BatchClassListView.vue?vue&type=template&id=343b2ed8&ts=true"
import script from "./BatchClassListView.vue?vue&type=script&lang=ts"
export * from "./BatchClassListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__